import {decorate, observable} from 'mobx';
import {faFileEdit} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel} from './base';

export class DocumentType extends BaseModel {
  static faIcon = faFileEdit;

  searchableProperties = ['name', 'label'];
}

decorate(DocumentType, {
  id: observable,
  name: observable,
  label: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
  deletedAt: observable,
  deletedBy: observable,
  expireDate: observable,
});
